/* Plush Companion template scripts: gallery, variant switching, review carousel, CTA strip. */
(function () {
  'use strict';

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* ---------- Hero: gallery + variants ---------- */
  function initHero(root) {
    if (!root || root.__pcInit) return;
    root.__pcInit = true;

    var slides = qsa(root, '[data-pc-slide]');
    var thumbs = qsa(root, '[data-pc-thumb]');
    var current = 0;

    function show(i, focusThumb) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === current;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        if (!on) { var v = qs(s, 'video'); if (v && !v.paused) v.pause(); }
      });
      thumbs.forEach(function (t, n) {
        if (n === current) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (focusThumb && thumbs[current]) thumbs[current].focus();
    }

    var prev = qs(root, '[data-pc-prev]');
    var next = qs(root, '[data-pc-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });

    var gallery = qs(root, '[data-pc-gallery]');
    if (gallery) {
      gallery.addEventListener('keydown', function (e) {
        if (e.target && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
      });
    }

    function showByMediaId(id) {
      if (!id) return;
      for (var n = 0; n < slides.length; n++) {
        if (String(slides[n].getAttribute('data-media-id')) === String(id)) { show(n); return; }
      }
    }

    /* variants */
    var dataEl = qs(root, '[data-pc-variants]');
    var form = qs(root, 'form[data-type="add-to-cart-form"]');
    if (!dataEl || !form) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; }
    var idInput = qs(form, 'input[name="id"]');
    var atc = qs(root, '[data-pc-atc]');
    var atcLabel = qs(root, '[data-pc-atc-label]');
    var priceEl = qs(root, '[data-pc-price]');
    var compareEl = qs(root, '[data-pc-compare]');
    var offEl = qs(root, '[data-pc-off]');
    var status = qs(root, '[data-pc-status]');
    var optionNames = qsa(root, '[data-pc-option-current]');
    var labels = {
      add: root.getAttribute('data-label-add') || 'Add to cart',
      soldOut: root.getAttribute('data-label-soldout') || 'Sold out',
      unavailable: root.getAttribute('data-label-unavailable') || 'Unavailable'
    };

    function selectedOptions() {
      var groups = {};
      qsa(root, '[data-pc-option-input]').forEach(function (input) {
        if (input.checked) groups[input.getAttribute('data-option-index')] = input.value;
      });
      return Object.keys(groups).sort(function (a, b) { return a - b; }).map(function (k) { return groups[k]; });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function setButton(state) {
      if (!atc) return;
      var disabled = state !== 'add';
      if (disabled) atc.setAttribute('disabled', 'disabled'); else atc.removeAttribute('disabled');
      if (atcLabel) atcLabel.textContent = labels[state === 'add' ? 'add' : state];
      document.dispatchEvent(new CustomEvent('pc:variant-state', { detail: { available: !disabled, label: labels[state === 'add' ? 'add' : state] } }));
    }

    function apply(v) {
      if (!v) {
        setButton('unavailable');
        if (status) status.textContent = labels.unavailable;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) {
        if (v.compare) { compareEl.textContent = v.compare; compareEl.classList.remove('pc-hidden'); } else { compareEl.classList.add('pc-hidden'); }
      }
      if (offEl) {
        if (v.off) { offEl.textContent = offEl.getAttribute('data-template').replace('[pct]', v.off); offEl.classList.remove('pc-hidden'); } else { offEl.classList.add('pc-hidden'); }
      }
      setButton(v.available ? 'add' : 'soldOut');
      if (status) status.textContent = v.available ? '' : labels.soldOut;
      showByMediaId(v.mediaId);
      if (window.history && history.replaceState && window.URL) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState(null, '', u.toString());
        } catch (err) { /* ignore */ }
      }
    }

    qsa(root, '[data-pc-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var opts = selectedOptions();
        optionNames.forEach(function (el) {
          if (el.getAttribute('data-option-index') === input.getAttribute('data-option-index')) el.textContent = input.value;
        });
        apply(findVariant(opts));
      });
    });

    /* initial state (also honours ?variant= from the URL, already resolved server-side) */
    var initial = findVariant(selectedOptions());
    if (initial) {
      setButton(initial.available ? 'add' : 'soldOut');
      showByMediaId(initial.mediaId);
    }
  }

  /* ---------- Review carousel ---------- */
  function initCarousel(root) {
    if (!root || root.__pcInit) return;
    root.__pcInit = true;
    var track = qs(root, '[data-pc-track]');
    var prev = qs(root, '[data-pc-rv-prev]');
    var next = qs(root, '[data-pc-rv-next]');
    if (!track) return;
    function step() {
      var card = qs(track, '.pc-card, .pc-gcard');
      return card ? card.getBoundingClientRect().width + 20 : track.clientWidth;
    }
    function update() {
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); }
    });
    qsa(root, '[data-pc-more]').forEach(function (btn) {
      var text = btn.previousElementSibling;
      if (text && text.scrollHeight <= text.clientHeight + 1) { btn.hidden = true; return; }
      btn.addEventListener('click', function () {
        var open = text.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      });
    });
    update();
  }

  /* ---------- Final CTA ---------- */
  function initCta(root) {
    if (!root || root.__pcInit) return;
    root.__pcInit = true;
    var btn = qs(root, '[data-pc-cta-btn]');
    if (!btn) return;
    var mode = root.getAttribute('data-action') || 'scroll';
    var defaultLabel = btn.textContent;
    function heroForm() { return document.querySelector('[data-pc-hero] form[data-type="add-to-cart-form"]'); }
    btn.addEventListener('click', function () {
      var hero = document.querySelector('[data-pc-hero]');
      if (mode === 'add') {
        var form = heroForm();
        var atc = hero && hero.querySelector('[data-pc-atc]');
        if (form && atc && !atc.disabled) {
          if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
          return;
        }
      }
      var target = document.getElementById('pc-product-form') || hero;
      if (target) {
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        var focusable = target.querySelector('input:checked, button, a');
        if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 400);
      }
    });
    if (mode === 'add') {
      document.addEventListener('pc:variant-state', function (e) {
        btn.disabled = !e.detail.available;
        btn.textContent = e.detail.available ? defaultLabel : e.detail.label;
      });
    }
  }

  /* ---------- Sale countdown (one fixed deadline set in the editor) ---------- */
  function initCountdown(root) {
    if (!root || root.__pcInit) return;
    root.__pcInit = true;
    var end = Date.parse(root.getAttribute('data-end'));
    if (isNaN(end)) return;
    var needsSale = root.getAttribute('data-needs-sale') === 'true';
    var parts = { h: qs(root, '[data-pc-cd="h"]'), m: qs(root, '[data-pc-cd="m"]'), s: qs(root, '[data-pc-cd="s"]') };
    var timer = null;
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function onSale() {
      if (!needsSale) return true;
      var cmp = document.querySelector('[data-pc-compare]');
      return !!cmp && !cmp.classList.contains('pc-hidden');
    }
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { root.hidden = true; if (timer) clearInterval(timer); document.removeEventListener('pc:variant-state', tick); return; }
      parts.h.textContent = pad(Math.floor(left / 3600));
      parts.m.textContent = pad(Math.floor((left % 3600) / 60));
      parts.s.textContent = pad(left % 60);
      root.hidden = !onSale();
    }
    tick();
    if (end > Date.now()) { timer = setInterval(tick, 1000); document.addEventListener('pc:variant-state', tick); }
  }

  /* Text-only sale message: just follows the compare-at price */
  function initSaleBox(root) {
    if (!root || root.__pcInit) return;
    root.__pcInit = true;
    if (root.getAttribute('data-needs-sale') !== 'true') return;
    function sync() {
      var cmp = document.querySelector('[data-pc-compare]');
      root.hidden = !(cmp && !cmp.classList.contains('pc-hidden'));
    }
    sync();
    document.addEventListener('pc:variant-state', sync);
  }

  function initAll(scope) {
    scope = scope || document;
    qsa(scope, '[data-pc-hero]').forEach(initHero);
    qsa(scope, '[data-pc-carousel]').forEach(initCarousel);
    qsa(scope, '[data-pc-cta]').forEach(initCta);
    qsa(scope, '[data-pc-countdown]').forEach(initCountdown);
    qsa(scope, '[data-pc-salebox]').forEach(initSaleBox);
    if (scope !== document) {
      [scope].forEach(function (el) {
        if (el.matches) {
          if (el.matches('[data-pc-hero]')) initHero(el);
          if (el.matches('[data-pc-carousel]')) initCarousel(el);
          if (el.matches('[data-pc-cta]')) initCta(el);
        }
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
